var React = require('react');

function NotebookOutline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M9 31H39V11H9V31ZM41 32V10C41 9.448 40.553 9 40 9H8C7.447 9 7 9.448 7 10V32C7 32.553 7.447 33 8 33H40C40.553 33 41 32.553 41 32ZM46 40C46 41.103 45.103 42 44 42H4C2.897 42 2 41.103 2 40V38H15H18C18 38.53 18.211 39.039 18.586 39.414C18.961 39.789 19.47 40 20 40H28C29.104 40 30 39.104 30 38H32H46V40ZM4 10C4 7.794 5.794 6 8 6H40C42.206 6 44 7.794 44 10V36H32H30C28.896 36 28 36.895 28 38H20C20 36.895 19.105 36 18 36H15H4V10ZM46 10C46 6.686 43.314 4 40 4H8C4.686 4 2 6.686 2 10V36C0.895 36 0 36.895 0 38V40C0 42.209 1.791 44 4 44H44C46.209 44 48 42.209 48 40V38C48 36.895 47.105 36 46 36V10Z","fill":"#CCCCCC"}));
}

NotebookOutline.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = NotebookOutline;

NotebookOutline.default = NotebookOutline;
